import { render, staticRenderFns } from "./default-polarBar.md?vue&type=template&id=11ce966a&"
import script from "./default-polarBar.md?vue&type=script&lang=js&"
export * from "./default-polarBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ce966a')) {
      api.createRecord('11ce966a', component.options)
    } else {
      api.reload('11ce966a', component.options)
    }
    module.hot.accept("./default-polarBar.md?vue&type=template&id=11ce966a&", function () {
      api.rerender('11ce966a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/PolarBar/default-polarBar.md"
export default component.exports